module.exports = new __parcel__URL__("shop_bk55_chip_image.7b0bb994.png").toString();